import { Value } from '@radix-ui/react-select';
import React from 'react';

import { cn } from '@/services/utils';

/**
 * The part that reflects the selected value.
 *
 * By default the selected item's text will be rendered. if you require more control, you can
 * instead control the select and pass your own children.
 *
 * It should not be styled to ensure correct positioning.
 *
 * An optional placeholder prop is also available for when the select has no value.
 */
const SelectValue = React.forwardRef<
    React.ElementRef<typeof Value>,
    React.ComponentPropsWithoutRef<typeof Value>
>(({ className, ...props }, ref) => (
    <Value
        ref={ref}
        className={cn(
            'tw-py-1.5 tw-pl-8 tw-pr-2 tw-text-t-sm tw-text-bold tw-truncate',
            className,
        )}
        {...props}
    />
));

SelectValue.displayName = Value.displayName;

export { SelectValue };
